var websites = {
  infodsi: {
    name: 'InfoDSI',
    category: 'manager_oid',
    secondCategory: 'managerc_oid',
    tag: 'infodsi',
    broadcastChannel: 'InfoDSI',
    url: 'infodsi.com',
    readMoreTags: [
      { tag: 'news', name: 'ITRNews', url: 'http://itrnews.com', color: 'originalRed' },
      { tag: 'mobiles', name: 'ITRMobiles', url: 'http://itrmobiles.com', color: 'orange' },
      { tag: 'games', name: 'ITRGames', url: 'http://itrgames.com', color: 'dark' },
      { tag: 'channel', name: 'ITChannel', url: 'http://itchannel.info', color: 'blue' },
    ],
    vimeoScope: 'channels/1319566',
  },
  itchannel: {
    name: 'ITChannel',
    category: 'theme_oid',
    secondCategory: 'sector_oid',
    tag: 'channel',
    broadcastChannel: 'ITChannel',
    url: 'itchannel.info',
    vimeoScope: 'channels/1319566',
    readMoreTags: [
      { tag: 'news', name: 'ITRNews', url: 'http://itrnews.com', color: 'originalRed' },
      { tag: 'mobiles', name: 'ITRMobiles', url: 'http://itrmobiles.com', color: 'orange' },
      { tag: 'games', name: 'ITRGames', url: 'http://itrgames.com', color: 'dark' },
      { tag: 'infodsi', name: 'InfoDSI', url: 'http://infodsi.com', color: 'violet' },
    ],
  },
  itrnews: {
    name: 'ITRNews',
    category: 'topic_oid',
    secondCategory: 'managerc_oid',
    tag: 'news',
    broadcastChannel: 'ITRNews',
    url: 'itrnews.com',
    vimeoScope: 'channels/1319566',
    readMoreTags: [
      { tag: 'infodsi', name: 'InfoDSI', url: 'http://infodsi.com', color: 'violet' },
      { tag: 'mobiles', name: 'ITRMobiles', url: 'http://itrmobiles.com', color: 'orange' },
      { tag: 'games', name: 'ITRGames', url: 'http://itrgames.com', color: 'dark' },
      { tag: 'channel', name: 'ITChannel', url: 'http://itchannel.info', color: 'blue' },
    ],
  },
};

export default {
  currentWebsite: function() {
    var websiteName = process.env.CURRENT_WEBSITE;
    if (!websites[websiteName]) {
      return null;
    }
    return websites[websiteName];
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/websites.js
// module id = null
// module chunks = 